export default function MisingPage () {
  return (
    <>
      <h1>404</h1>
    </>
  )
}
